// Plan details used across admin pages (display info only — no icon references)
export const PLAN_DETAILS = {
  basic: { name: 'BASIQUE', color: '#10b981' },
  'private-basic': { name: 'PRIVÉ BASIQUE', color: '#3b82f6' },
  standard: { name: 'STANDARD', color: '#f59e0b' },
  premium: { name: 'PREMIUM', color: '#8b5cf6' },
  university: { name: 'UNIVERSITÉ', color: '#06b6d4' },
  elite: { name: 'ÉLITE', color: '#dc2626' },
};
